var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr"},[_c('div',{ref:"qrCodeImg",attrs:{"id":"qrcode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }